import { queryOptions, useQuery } from '@tanstack/react-query'
import { getFormDefinition } from '../../services/ruutsApi/formDefinitions/getFormDefinition'
import getDataCollectionFormDefinitions from '../../services/ruutsApi/formDefinitions/getFormDefinitions'
import type { ProgramConfig } from '../../types/apiModels'
import { queryKeys } from './queryKeys'

// Form definitions are immutable per deploy, so both hooks pin staleTime to Infinity:
// once fetched, a definition never needs to refetch for the lifetime of the session.
export const formDefinitionQueryOptions = (id: string | undefined) =>
  queryOptions({
    queryKey: queryKeys.formDefinition(id),
    queryFn: ({ signal }) => getFormDefinition({ id: id as string, signal }),
    staleTime: Infinity,
  })

export const useFormDefinition = (id: string | undefined) =>
  useQuery({
    ...formDefinitionQueryOptions(id),
    enabled: !!id,
  })

// Keyed by programConfig.id (not the selected farm): two farms on the same program share
// the same cached list. React Query dedupes the concurrent FormContainer/DataCollectionForm
// calls to this key, so deriving the active definition in each consumer costs no extra request.
export const useFormDefinitions = (programConfig: ProgramConfig | undefined) =>
  // eslint-disable-next-line @tanstack/query/exhaustive-deps -- the definition list belongs to the program config that programConfig.id identifies
  useQuery({
    queryKey: queryKeys.formDefinitions(programConfig?.id),
    queryFn: ({ signal }) =>
      getDataCollectionFormDefinitions({ programConfig: programConfig as ProgramConfig, signal }),
    enabled: !!programConfig?.id,
    staleTime: Infinity,
  })
